import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum SystemPopupTypes {
  CreditsPurcased = 1,
  CreditsWelcomeGift,
  CreditsInsufficient,
  CreditsRefill,
}

interface SystemPopupState {
  type: SystemPopupTypes | null;
  params: any;
}

const initialState: SystemPopupState = {
  type: null,
  params: null,
};

const systemPopupSlice = createSlice({
  name: 'systemPopup',
  initialState,
  reducers: {
    setActiveSystemPopup(
      state,
      action: PayloadAction<{ type: SystemPopupTypes; params?: any }>
    ) {
      state.type = action.payload.type;
      state.params = action.payload.params || null;
    },

    closeSystemPopup(state) {
      state.type = null;
      state.params = null;
    },
  },
});

export const { setActiveSystemPopup, closeSystemPopup } =
  systemPopupSlice.actions;

export const systemPopup = systemPopupSlice.reducer;
